import * as constants from './constants';

const getStoryDetailsLaunched = id => {
  return {
    type: constants.STORY_DETAILS_LAUNCHED,
    id
  };
};

const getStoryDetailsSuccess = (story, pointsOfInterest) => {
  return {
    type: constants.STORY_DETAILS_SUCCESS,
    story,
    pointsOfInterest
  };
};

const getStoryDetailsFailure = errors => {
  return {
    type: constants.STORY_DETAILS_FAILURE,
    errors
  };
};

export { getStoryDetailsFailure, getStoryDetailsSuccess, getStoryDetailsLaunched };
